"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDiet = void 0;
var IDiet;
(function (IDiet) {
    IDiet["Paleo"] = "paleo";
    IDiet["Vegan"] = "vegan";
    IDiet["Vegetarian"] = "vegetarian";
})(IDiet || (exports.IDiet = IDiet = {}));
//# sourceMappingURL=diet.js.map